module.exports = __webpack_public_path__ + "static/rowIcon6.93ccfd41.svg";